import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { MaterialModule } from '@angular/material';

import { DataTableModule } from 'primeng/primeng';

import { UsersComponent } from './users.component';
import { UserListComponent } from './userlist/user-list.component';
import { UserComponent } from './user/user.component';

import { UserService } from './user.service';

@NgModule({
    declarations: [
        UsersComponent,
        UserListComponent,
        UserComponent
    ],
    imports: [
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        DataTableModule,
        FlexLayoutModule,
    ],
    providers: [
        UserService
    ],
    entryComponents: [
        UserComponent
    ]
})

/**
 * Main module for the user managements.
*/
export class UsersModule { }



// WEBPACK FOOTER //
// ./src/app/admin/users/users.module.ts